import { useEffect, useState } from 'react';
import { LoadedFloorPlanMedia } from './useFloorPlanMedia';

export const useCanvasSize = (containerRef: React.RefObject<HTMLDivElement>, media: LoadedFloorPlanMedia) => {
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const updateSize = () => {
            if (!containerRef.current) return;

            const { width } = containerRef.current.getBoundingClientRect();
            const roundedWidth = Math.round(width);

            const height = media
                ? Math.round((media.naturalHeight / media.naturalWidth) * roundedWidth)
                : Math.round(roundedWidth * 0.6);

            setCanvasSize((prev) => {
                if (prev.width === roundedWidth && prev.height === height) return prev;
                return { width: roundedWidth, height };
            });
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, [containerRef, media]);

    return canvasSize;
};
